import { Heading } from 'blaze-ui/Heading/Heading'
import Styles from './Schedule.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { filterDOMProps, useId } from '@react-aria/utils'
import { StartDatePicker } from 'screens/Campaigns/components/AddCampaignModal/CreateCampaign/StartDatePicker'
import { LengthSelect } from 'screens/Campaigns/components/AddCampaignModal/CreateCampaign/LengthSelect'
import { AriaLabelingProps } from '@react-types/shared'

interface ScheduleFieldsProps extends AriaLabelingProps {
  startDateField?: string
}

export const ScheduleFields = ({ startDateField = 'startDate', ...props }: ScheduleFieldsProps) => {
  const lengthLabelId = useId()
  const startDateLabelId = useId()

  return (
    <div className={Styles.fields} role="group" {...filterDOMProps(props, { labelable: true })}>
      <div className={Styles.datePicker}>
        <Text variant="primary" color="var(--dark-40)" id={startDateLabelId}>
          Starts on
        </Text>
        <StartDatePicker name={startDateField} aria-labelledby={startDateLabelId} />
      </div>
      <div className={Styles.datePicker}>
        <Text variant="primary" color="var(--dark-40)" id={lengthLabelId}>
          Length
        </Text>
        <LengthSelect name="length" aria-labelledby={lengthLabelId} />
      </div>
    </div>
  )
}

export const Schedule = (props: { startDateField?: string }) => {
  return (
    <div className={Styles.schedule}>
      <Heading level={4}>Campaign Schedule</Heading>
      <ScheduleFields {...props} />
    </div>
  )
}
